const FacilityJobs = (() => {
	    // Get the select element by its ID
    const selectElement = document.getElementById('id_facility');

	if (!selectElement) {
        return void 0;
    }

    // Listen for changes on the select element
    selectElement.addEventListener('change', (e) => {
        // Get the value of the selected option
        const selectedValue = e.target.value;

        // Check if the selected value is 'GEE' or 'BAL'
        if (selectedValue === 'GEE' || selectedValue === 'BAL') {
            // Get the parent form of the select element
            // const form = this.closest('form');
            const form = e.target.closest('form');

            // Find all input elements within the form
            const inputs = form.querySelectorAll('input, select, textarea');

            // Loop through all input elements and make them not required
            inputs.forEach(function(input) {
                input.removeAttribute('required');
            });
        } else {
            // Optionally, reset the requirement when other options are selected
            const form = this.closest('form');
            const inputs = form.querySelectorAll('input, select, textarea');

            inputs.forEach(function(input) {
                if (input.dataset.wasRequired === "true") {
                    input.setAttribute('required', '');
                }
            });
        }
    });

    // Initial setup to mark inputs that are initially required
    const form = selectElement.closest('form');
    const inputs = form.querySelectorAll('input[required], select[required], textarea[required]');
    inputs.forEach(function(input) {
        input.dataset.wasRequired = "true";
    });

	return void 0;
})();